import {InfoItem} from "./MyPage/InfoItem";
import moment from "moment";
import React from "react";

type TOrderNumberSection = {
    orderNumber: string
    orderedAt: string
}

export default (props: TOrderNumberSection) => {
    const {orderNumber, orderedAt} = props;

    return (
        <div className="grid md:grid-cols-2">
            <InfoItem title="주문 번호" content={orderNumber}/>
            <InfoItem title="주문 일자" content={moment(orderedAt).format('YYYY.MM.DD')}/>
        </div>
    )
}
